import DesktopSiteBanner from './DesktopSiteBanner';

export default DesktopSiteBanner;
